import { useEffect, useState } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import {
  readStoredPreference,
  setThemePreference,
  watchSystemTheme,
  type ThemePreference,
} from '../theme';

const OPTIONS: { value: ThemePreference; label: string; icon: typeof Sun }[] = [
  { value: 'system', label: 'Auto', icon: Monitor },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
];

/** Segmented Auto / Light / Dark control for the account menu. */
export function ThemeToggle() {
  const [preference, setPreference] = useState<ThemePreference>(() => readStoredPreference());

  // While on "Auto", follow the device flipping between light and dark.
  useEffect(() => {
    if (preference !== 'system') return;
    return watchSystemTheme(() => setThemePreference('system'));
  }, [preference]);

  const choose = (value: ThemePreference) => {
    setPreference(value);
    setThemePreference(value);
  };

  return (
    <div className="theme-toggle" role="group" aria-label="Colour scheme">
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          className={`theme-toggle__btn${preference === value ? ' theme-toggle__btn--active' : ''}`}
          aria-pressed={preference === value}
          onClick={() => choose(value)}
        >
          <Icon size={14} aria-hidden="true" />
          {label}
        </button>
      ))}
    </div>
  );
}
